<div *ngIf="displayError">
  <bb-alert-ui>
    <span>
      {{ errorMessage }}
    </span>
  </bb-alert-ui>
</div>

<div style="display: none;">
  <div i18n="@@otp-validation-invalid-otp">Invalid OTP</div>
  <div i18n="@@otp-validation-expired-otp">Expired code</div>
  <div i18n="@@otp-validation-user-disabled">User is disabled</div>
  <div i18n="@@otp-validation-default-error">Something went wrong</div>
  <div i18n="@@otp-validation-wait-for-attempt">A new verification code is not allowed at this moment</div>
</div>